import apiFetch from '../apiFetch'

export default function (token, filter) {
  return apiFetch({ endPoint: 'OperationType/Table', method: 'POST', body: filter, token: token })
}
